import { BankDetailsType } from '../../../../hooks/useBank';
import { IsAllow } from '../../../../redux-store/types/portfolio';
import { CommercialRootPath } from '../routeConfig';

export const PAUSE = 'Pause';
export const CANCEL = 'Cancel';

export const SipPaths = {
    Sip: '/sip',
    SipDetails: '/:id/sip',
    SipOTP: `/sip-pause/verify-otp`,
    SipSuccess: '/sip-pause/status',
};

export type SipSummaryObjectType = {
    rtaName: string;
    isin: string;
    amc: string;
    amcName: string;
    folio: string;
    schemeCode: string;
    schemeName: string;
    userTrxnNo: string;
    amount: string;
    startDate: string;
    endDate: string;
    frequency: string;
    noOfInstallments: string;
    sipDate: string;
    lastExecutedDate: string;
    bank: Omit<BankDetailsType, 'neftIfsc'>;
    payInMech: string;
    registrationSource: string;
    accumulatedAmount: string;
    omUmrn: string;
    sipStatus: 'Active' | 'Paused' | 'Cancel' | 'Completed';
};

export type SipResponseType = {
    body: {
        data: Array<SipSummaryObjectType>;
    };
};

export type SipTransactionPayloadType = {
    txnType: 'SIP' | 'SWP' | 'STP';
    folio: string;
    schemeCode: string;
    userTrxnNo: string;
};

export type SipTransactionRequestType = {
    amc: string;
    data: [SipTransactionPayloadType];
};

export type SipTransactionPropsType = {
    payload: SipTransactionPayloadType;
    amcCode: string;
};

export type SipTransactionObjectType = {
    instalmentNumber: string;
    nav: string;
    navDate: string;
    units: string;
    instalmentAmount: string;
    instalmentDate: string;
    processedDate: string;
    status: string;
};

export type SipTransactionResponseType = {
    body: {
        data: Array<SipTransactionObjectType>;
    };
};

export type SipCancelReasonsResponseType = Array<{
    code: number;
    reason: string;
}>;

export type ParsedSipCancelReasonsResponseType = Array<SelectedSipReason>;

export type SelectedSipReason = {
    code: string;
    reason: string;
};

type SIPValidateSchemeOptionsType<TrxnType extends 'CSIP' | 'PSIP'> = {
    folio: string;
    itemNo: string;
    isin: string;
    schemeCode: string;
    userTrxnNo: string;
    trxnType: TrxnType;
    pauseInstallments: string;
};

export type SIPValidateRequestType = {
    data: Array<{
        amc: string;
        code: string;
        reason: string;
        schemeOptions: Array<SIPValidateSchemeOptionsType<'PSIP' | 'CSIP'>>;
    }>;
};

export type SIPValidationResponseType = {
    body: {
        reqId: string;
        success: Array<{
            folio: string;
            userTrxnNo: string;
            rxnType: string;
            isPauseAllowed: IsAllow;
            isCancelAllowed: IsAllow;
            effectiveDate: string;
            remarks: string;
        }>;
    };
};
export type SIPSubmitRequestType = SIPValidateRequestType;
export type SIPSubmitResponseType = {
    body: {
        success: Array<{
            code: string;
            amc: string;
            amcName: string;
            itemNo: string;
            folio: string;
            schemeName: string;
            transactionType: string; //SIP CANCEL  - PSIP - SIP PAUSE
            amount: string;
            units: string;
            nav: string;
            navDate: string;
            paymentType: string;
            switchIn: {};
            payment: {};
            message: string;
            techMessage: string;
            entryDateTime: string;
            transactionStatus: string;
            sip: {};
            stpSwp: {};
            systematicPauseCancel: {
                userTrxnNo: string;
                effectiveDate: string;
            };
        }>;
    };
};
